import { makeStyles } from "@material-ui/core";
import { DashboardHeader } from "pages/admin/dashboard/components/general";
const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: 5, },
    '&::-webkit-scrollbar-thumb': { background: '#999999' }
  },
  chart: {
    width: '100%',
    height: '100%',
  },
  wrapRow: {
    padding: "10px 10px", borderBottom: "1px solid #F3f3f3",
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  wrapUser: {
    display: "flex", flexDirection: "column"
  },
  userInfo: {
    color: "#426492", fontSize: "12px", fontWeight: "bold"
  },
  wrapHeadRow: {
    padding: "5px 10px",
  },
  wrapRequestNum: {
    display: 'flex',
    // justifyContent: ''
  },
  requestNum: {
    color: "#707070", width: "80px", fontSize: "11px", fontWeight: "500"
  }
}));


const data = [
  {
    topic: "T0001 - ยื่นคำขอ Smart T",
    started: '5 hours ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
  {
    topic: "T0002 - ยื่นคำขอ Smart I",
    started: '12 hours ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
  {
    topic: "T0003 - ยื่นคำขอ Smart E",
    started: '1 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'
  },
  {
    topic: "DEPA ยกเลิกคำร้อง T0001",
    started: '3 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },

  {
    topic: "NIA  ยกเลิกคำร้อง T0001",
    started: '4 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
]

function Webboard() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="Webboard" />
      </div>
      <div className={classes.wrapChart}>
        {
          data.map((d, index) => (
            <div key={index} className={classes.wrapRow}>
              <div className={classes.wrapUser}>
                <div className={classes.userInfo}>
                  {d.topic}
                </div>
                <div style={{ color: "#707070", fontSize: "12px", marginTop: "5px" }}>
                  {d.createBy}
                </div>
              </div>
              <div className={classes.wrapRequestNum}>
                <div className={classes.requestNum}>
                  {d.started}
                </div>
              </div>

            </div>
          ))
        }

      </div>
    </>
  )
}


export default Webboard;